import React from "react";
import css from "../Data.module.css";

const ColorPalette = ({ palette, setPalette }) => {
  return (
    <div className={css.colorPalette}>
      <div>
        Color palette:{" "}
        <select
          value={palette}
          onChange={(event) => setPalette(event.currentTarget.value)}
        >
          {colorList.map((col) => {
            return (
              <option value={col.value} key={col.name}>
                {col.name}
              </option>
            );
          })}
        </select>
      </div>
      <div style={{ display: "grid", gridTemplateColumns: "auto 60% auto" }}>
        <div style={{ placeSelf: "center" }}>Low</div>
        <div
          style={{
            background: paletteDiv[palette].background,
            backgroundImage: paletteDiv[palette].backgroundImage,
            placeSelf: "center",
            height: "50%",
            width: "100%",
          }}
        ></div>
        <div style={{ placeSelf: "center" }}>High</div>
      </div>
    </div>
  );
};

export default ColorPalette;

const colorList = [
  { name: "Viridis", value: "viridis" },
  { name: "Magma", value: "magma" },
  { name: "RdBu", value: "RdBu" },
  { name: "PRGn", value: "PRGn" },
  { name: "PuOr", value: "PuOr" },
];

// Per aggiungere altri colori, vedere qui e poi controllare se il nome esiste in matplotlib come palette
// https://bennettfeely.com/scales/
const paletteDiv = {
  viridis: {
    background: "#4a7d70",
    backgroundImage:
      "linear-gradient(90deg, #440154, #482475, #414487, #355f8d, #2a788e, #21908d, #22a884, #42be71, #7ad151, #bddf26, #bddf26)",
  },
  RdBu: {
    background: "#a88d9a",
    backgroundImage:
      "linear-gradient(to left, #67001f, #ab202e, #d55f50, #f0a285, #fad6c3, #f2efee, #cde3ee, #90c2dd, #4b94c4, #2265a3, #2265a3)",
  },
  magma: {
    background: "#944664",
    backgroundImage:
      "linear-gradient(90deg, #000004, #140e36, #3b0f70, #641a80, #8c2981, #b5367a, #de4968, #f66e5c, #fe9f6d, #fecf92, #fecf92)",
  },
  PRGn: {
    background: "#95989d",
    backgroundImage:
      "linear-gradient(90deg, #40004b, #722e80, #9a6daa, #c1a4cd, #e3d2e6, #eff0ef, #d6eed1, #a2d79f, #5dad65, #217939, #217939)",
  },
  PuOr: {
    background: "#bb9283",
    backgroundImage:
      "linear-gradient(to left, #7f3b08, #b15a09, #dd841f, #f8b664, #fdddb2, #f3eeea, #d7d7e9, #b0aad0, #8170ad, #552d84, #552d84)",
  },
};

